import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Loader } from '../Common/Loader/loader';
import { useSelector } from 'react-redux';
import timezone from 'dayjs/plugin/timezone'
import { useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Typography, Button } from '@mui/material';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ErrorView } from '../Common/ErrorComponents/errorView'
import paths from '../../Infrastructure/Router/paths';
import enrollmentCompleteSX from './styles';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const EnrollmentComplete = () => {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get("uuid")
    const class_id = urlParams.get('class_id');
    const [classDetails, setClassDetails] = useState(null);
    const [timeoutReached, setTimeoutReached] = useState(false);
    const userData = useSelector((state) => state.userData.data);
    const loading = useSelector((state) => state.userData.loading);
    const courseName = classDetails?.course_title;
    const duration = classDetails?.duration;
    const first_class = parseInt(classDetails?.first_class, 10);
    const last_class = parseInt(classDetails?.last_class, 10)
    const educator = classDetails?.educator;
    const firstClass = dayjs(first_class).tz(dayjs.tz.guess()).format('dddd, MMMM Do YYYY [at] hh:mm A')
    const lastClass = dayjs(last_class).tz(dayjs.tz.guess()).format('dddd, MMMM Do YYYY [at] hh:mm A')
    //  eslint-disable-next-line eqeqeq
    const durationLabel = `${duration} ${duration == "1" ? "Week" : "Weeks"}`;

    useEffect(() => {
        const classDetails = userData && userData?.student?.classes[class_id];
        setClassDetails(classDetails);
        const timer = setTimeout(() => {
            if (!classDetails) {
                setTimeoutReached(true);
            }
        }, 30000); // 30 seconds
        return () => clearTimeout(timer)
    }, [userData, userData?.student?.classes, class_id])
    if (timeoutReached && !classDetails) {
        return (
            <Box height={'100vh'} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                <ErrorView/>
            </Box>
        );
    }
    return (
        <Box sx={enrollmentCompleteSX.pageContainer}>
            <Box sx={enrollmentCompleteSX.contentBox}>
                {classDetails && !loading ? (
                    classDetails?.uuid === uuid ? (
                        <>
                            {classDetails.payment_status === "pending" ? (
                                <Box sx={enrollmentCompleteSX.statusBox}>
                                    <HourglassEmptyIcon color="primary" sx={enrollmentCompleteSX.pendingIcon} />
                                    <Typography sx={enrollmentCompleteSX.pendingTitle} variant="body1">
                                        Enrollment Pending
                                    </Typography>
                                    <Typography sx={enrollmentCompleteSX.pendingText} variant="body1">
                                        Your enrollment for the <b>{courseName}</b> course is pending. Once the payment is processed, you will receive confirmation.
                                        Check back later or contact customer support if you have any questions.
                                    </Typography>
                                    <Button variant="contained" color="primary" onClick={() => navigate(paths.dashboardPage.path)}>
                                        Back to Dashboard
                                    </Button>
                                </Box>
                            ) : classDetails.payment_status === "success" ? (
                                <>
                                    <Box>
                                        <CheckCircleOutlineIcon color="success" sx={enrollmentCompleteSX.successIcon} />
                                    </Box>
                                    <Box sx={enrollmentCompleteSX.successInfoBox}>
                                        <Typography sx={enrollmentCompleteSX.successTitle} variant="body1">
                                            Enrollment Complete!
                                        </Typography>
                                        <Typography sx={enrollmentCompleteSX.successText} variant="body1">
                                            <b>{courseName}</b> course successfully enrolled! Your educator is <b>{educator}</b>,
                                            your first day of class is on <b>{" "}{firstClass}{" "}</b> and the last day of class will be on<b>{" "}{lastClass}{" "}</b>
                                            and the course duration is <b>{durationLabel}</b>. You can see and manage your courses in your dashboard.
                                        </Typography>
                                        <Button variant="contained" color="primary" onClick={() => navigate(paths.dashboardPage.path)}>
                                            See Dashboard
                                        </Button>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Box>
                                        <CancelIcon color="error" sx={enrollmentCompleteSX.errorIcon} />
                                    </Box>
                                    <Typography sx={enrollmentCompleteSX.errorText} variant="body1">
                                        An error occurred while processing your payment, please contact customer support
                                    </Typography>
                                    <Button sx={enrollmentCompleteSX.button} variant="contained" color="primary" onClick={() => navigate(paths.contactPage.path)}>
                                        Customer Support
                                    </Button>
                                </>
                            )}
                        </>
                    ) : (
                        // uuid mismatch
                        <>
                            <CancelIcon color="error" sx={enrollmentCompleteSX.errorIcon} />
                            <Typography sx={enrollmentCompleteSX.errorText}>
                                This enrollment attempt is no longer valid. Please try again.
                            </Typography>
                            <Button sx={{ mt: 2 }} variant="contained" onClick={() => navigate(paths.dashboardPage.path)}>
                                Back to Dashboard
                            </Button>
                        </>
                    )
                ) : (
                    <Box sx={enrollmentCompleteSX.loaderBox}>
                        <Loader />;
                    </Box>
                )}
            </Box>
        </Box>
    )
}
